module.exports = __webpack_public_path__ + "static/media/ico-trash.2a9ce796.svg";